import { create } from "sheetly";
export let text = ".container{display:flex}.images{display:flex;width:10em;gap:.5em}.info{display:flex;align-items:center}";
export const sheet = create(text, import.meta.url);
